import type { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

type Props = {
  children: ReactNode;
  redirectTo?: string;
};

const ProtectedRoute: FC<Props> = ({ children, redirectTo = '/login' }) => {
  const location = useLocation();

  const token =
    typeof window !== 'undefined' && window.localStorage
      ? window.localStorage.getItem('access_token')
      : null;

  if (!token || token === 'undefined') {
    const from = location.pathname + location.search;
    return <Navigate to={redirectTo} replace state={{ from }} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
